module.exports = __webpack_public_path__ + "files/f5a113f2b42eaf3fa25fe02f142e5525.png";